module.exports = __webpack_public_path__ + "img/logo-brighter@2x.9a55d3c5.png";